function SingleValueDisplay({
  display,
  fieldKey,
  inert,
  readOnly,
  preventClickHandler,
  showLinkIcon,
  displayValue,
  valueIsFX,
  displayPercentSuffix,
  percentValue,
  displayOnlyPercentage,
  Viewer,
}) {
  const truncateValue = true

  return (
    <>
      <div className="flex truncate">
        {displayValue && (
          <>
            <div className="truncate">
              {Viewer(
                fieldKey,
                display,
                inert,
                readOnly,
                preventClickHandler,
                showLinkIcon,
                truncateValue
              )}
            </div>
            {valueIsFX && (
              <div className="ml-1 self-center text-xs italic">
                {display.unit}
              </div>
            )}
          </>
        )}
        {displayPercentSuffix && (
          <div className="ml-1 self-center text-xs text-neutral-5">
            {" "}
            ({percentValue}%)
          </div>
        )}
        {displayOnlyPercentage && (
          <div className="truncate">{percentValue}%</div>
        )}
      </div>
    </>
  )
}

export default SingleValueDisplay
